import {useId} from 'react';
import {ConfirmFormRow} from '../confirm-form-row';
import {type FormSchema} from '@/features/company-registration/form';
import companyRegistrationPageStyles from '@/features/company-registration/styles.module.css';

type Props = Pick<FormSchema, 'contactPersonInfo'>;

export function ConfirmContactPersonInformationSection({
  contactPersonInfo,
}: Props) {
  const id = useId();
  const formTitleId = `${id}-formTitle`;

  return (
    <section
      aria-labelledby={formTitleId}
      className={companyRegistrationPageStyles.container}
    >
      <div className={companyRegistrationPageStyles.header}>
        <h2
          className={companyRegistrationPageStyles.formTitle}
          id={formTitleId}
        >
          担当者情報
        </h2>
      </div>

      <div className={companyRegistrationPageStyles.rows}>
        <ConfirmFormRow labelText='メールアドレス'>
          {contactPersonInfo.email}
        </ConfirmFormRow>

        <ConfirmFormRow labelText='パスワード'>
          {contactPersonInfo.password.replaceAll(/./g, '*')}
        </ConfirmFormRow>

        <ConfirmFormRow labelText='所属部署'>
          {contactPersonInfo.department}
        </ConfirmFormRow>

        <ConfirmFormRow labelText='氏名'>
          {contactPersonInfo.firstName} {contactPersonInfo.lastName}
        </ConfirmFormRow>

        <ConfirmFormRow labelText='氏名（カナ）'>
          {contactPersonInfo.firstNameKana} {contactPersonInfo.lastNameKana}
        </ConfirmFormRow>

        <ConfirmFormRow labelText='電話番号'>
          {contactPersonInfo.phoneNumber}
        </ConfirmFormRow>

        <ConfirmFormRow labelText='FAX'>{contactPersonInfo.fax}</ConfirmFormRow>
      </div>
    </section>
  );
}
